import React, { useState, useEffect } from 'react';
import { Button, Modal, Table, Tab, Tabs } from "react-bootstrap";
import Moment from 'react-moment';
import Paginate from "../../components/Paginate";
import moment from "moment-timezone";
import NBAPlayerpic from "../../assets/player-porzingis.png";
import TeamLogo1 from "../../assets/celtics-logo.png";
import TeamLogo2 from "../../assets/nuggets-logo.png";
import * as commonService from "../../services/commonService";
import * as playerStatsService from "../../services/playerStatsService";
const PlayerStats = props => {

    const [gameStats, setGameStats] = useState([]);


    const totalStats_data = {
        totalYards: 2500,
        totalTds: 25,
        totalINTs: 5,
    };


    
    const displayGameTime_data = (date) => moment.utc(date).format("hh:mm A");

    const [selectedTab, setSelectedTab] = useState('news');
    const [injuryReportLoaded, setInjuryReportLoaded] = useState(false);
    const [injuryReports, setinjuryReports] = useState({});
    const [showLoader, setLoader] = useState(false);
    const [showGameLogLoader, setgameLogLoader] = useState(false);
    const [newsPageData, setNewsPageData] = useState([]);
    const [newsList, setnewsList] = useState([]);
    const [currentSeason, setCurrentSeason] = useState('2025');
    const [seasonWeeks, setSeasonWeeks] = useState([]);
    const [playerDetails, setplayerDetails] = useState();
    const [gameLogs, setGameLogs] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    let defaultTotalStats = {
        'totalMin': 0,
        'totalFGPercentage': 0,
        'totalThreePointPerc': 0,
        'totalFreeThrowPerc': 0,
        'totalRebounds': 0,
        'totalAssists': 0,
        'totalBLK': 0,
        'totalSTL': 0,
        'totalTO': 0,
        'totalPTS': 0,
        'totalWeeklyScore' : 0
    };


    let summaryStats = {
        'totalFGPercentage': 0,
        'totalRebounds': 0,
        'totalAssists': 0,
        'totalPTS': 0
    };
    const [totalStats, setTotalStats] = useState(defaultTotalStats);
    const [statsSummary, setstatsSummary] = useState(summaryStats);
    const initialPageParams = {
        page: 1
    }
    const [newsPageParams, setNewsPageParams] = useState(initialPageParams);
    const [nextGameDetails, setNextGameDetails] = useState([]);

    const playerId = props.playerData.playerId;
    const team_key = props.playerData.team;
    let position = props.playerData.position.toUpperCase().trim();

    //Tab Changes
    const changeTabs = async (selectedTab) => {
        setSelectedTab(selectedTab)
    }



    const displayGameTime = (date) => {
        try {
            return moment.utc(date).tz("America/New_York").format('h:mm A z')
        } catch (error) {
            return "-";
        }
    }

    useEffect( () => {
       fetchPlayerStats()
    },[playerId,team_key, position]);

    useEffect(() => {
        if(selectedTab === 'injury-report' && !injuryReportLoaded) {
            fetchPlayerInjuryReport()
        }
     },[selectedTab]);

    const fetchPlayerInjuryReport = async() => {
        setLoader(true)
        await commonService.getInjuryReportsV2('NBA', playerId)
        .then(async function (response) {
            setLoader(false)
            setInjuryReportLoaded(true)
            if(response.errorCode == 200) {
                setinjuryReports(response.data.inuryData);
            } else {
                setinjuryReports([]);
            }
        })
    }

    
    const fetchPlayerStats = async() => {
        let weekRange = await commonService.numberrange(1,25,1);
        
       setTotalStats(defaultTotalStats);
       setSeasonWeeks(weekRange);
        //setLoader(true)
        await playerStatsService.getNBAPlayerStats(playerId)
            .then(async function (response) {
                setgameLogLoader(false)
                setLoader(false)
                if(response.errorCode === 200) {
                    setnewsList(response.data.newsData);
                    setNewsPageData({
                        perPage: response.data.perPage ? response.data.perPage : 5,
                        totalPages: response.data.totalPages ? response.data.totalPages : 0,
                        total: response.data.total ? response.data.total : 0,
                        currentPage: response.data.currentPage ? response.data.currentPage : 0,
                        errorCode: response.errorCode ? response.errorCode : 0,
                    });
                    setCurrentSeason(response.data.currentSeason);
                    setplayerDetails(response.data.playerDetails);
                    if(response.data.playerStats.length) {
                        const weeklyStats = response.data.playerStats.sort(function(a, b)
                            {
                            var x = a['schedule_date']; var y = b['schedule_date'];
                            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                            });


                        const upcomingGames = weeklyStats.find(gameData => {
                            return gameData.nba_week >= response.data.current_week && !gameData.is_game_started && !gameData.is_schedule_canceled;
                        });
                        setNextGameDetails(upcomingGames);
                        SeasonSummary(weeklyStats)
                        setGameStats(weeklyStats)
                    } else {
                        setGameStats([])
                    }
                    // createGameLogArray(response.data.playerStats, response.data.playerDetails.player_position)
                    setPageLoaded(true)
                } else {
                    setnewsList([]);
                    setplayerDetails([]);
                    setGameLogs([])
                    setPageLoaded(true)
                }
        })
    }

    const setQuarterDescription = (quarter_label) => {
        switch(quarter_label) {
          case "1":
            return 'Q1';
          case "2":
            return 'Q2';
          case "3":
            return 'Q3';
          case "4":
            return 'Q4';
          default:
              return '';
      }
    }


    const createWeekRow = (index, game) => {
        let gameSymbol = '@';
        let winningStatus;
        let finalScore ;
        if(game && game.home_team === playerDetails.team_key) {
            gameSymbol = 'VS';
        }

        if(game.home_team == playerDetails.team_key) {
            if(game.home_score > game.away_score && game.is_over) { //Game completed
                winningStatus = 'W';
            } else if(game.home_score == game.away_score && game.is_over) { //Game completed
                winningStatus = 'T';
            } else if(game.is_over){ //Game completed
                winningStatus = 'L';
            } else if(game.is_inprogress){ //Game in progress
                winningStatus = game.quater_desc;
            }
            finalScore = game.home_score+'-'+game.away_score;
        } else if(game.away_team == playerDetails.team_key ) {
            if(game.away_score > game.home_score && game.is_over) { //Game completed
                winningStatus = 'W';
            } else if(game.away_score == game.home_score && game.is_over) { //Game completed
                winningStatus = 'T';
            } else if(game.is_over){ //Game completed
                winningStatus = 'L';
            } else if(game.is_inprogress){ //Game in progress
                winningStatus = setQuarterDescription(game.quater_desc);
            }
            finalScore = game.away_score+'-'+game.home_score;
        }
        let freeThrowAPercentage = 0;
        let freeThrowAttempted = (game && game?.free_throw_attempt) ? Number( game?.free_throw_attempt) : 0;
        let freeThrowAMade = (game && game?.free_throw_made) ? Number( game?.free_throw_made) : 0;
        freeThrowAPercentage = (freeThrowAttempted > 0) ? (Number(freeThrowAMade)/Number(freeThrowAttempted))*100 : 0;

        let threeFGPointPercentage = 0;
        let threeFGPointAttempted = (game && game?.fieldgoal_attempt) ? Number( game?.fieldgoal_attempt) : 0;
        let threeFGPointAMade = (game && game?.fieldgoal_made) ? Number( game?.fieldgoal_made) : 0;
        threeFGPointPercentage = (threeFGPointAttempted > 0) ? (Number(threeFGPointAMade)/Number(threeFGPointAttempted))*100 : 0;


        let threePointPercentage = 0;
        let threePointAttempted = (game && game?.fieldgoal_3pt_attempt) ? Number( game?.fieldgoal_3pt_attempt) : 0;
        let threePointAMade = (game && game?.fieldgoal_3pt_made) ? Number( game?.fieldgoal_3pt_made) : 0;
        threePointPercentage = (threePointAttempted > 0) ? (Number(threePointAMade)/Number(threePointAttempted))*100 : 0;
        
        let minutePlayed = (game && game?.min_seconds) ? Number( game?.min_seconds) : 0;
        const totalAssist = (game && game?.offense_assists) ? Number( game?.offense_assists) : 0;
        const totalRebounds = (game && game?.total_rebounds) ? Number( game?.total_rebounds) : 0
        const totalBlocks = (game && game?.defense_blocks) ? Number( game?.defense_blocks) : 0;
        const totalSteals = (game && game?.defense_steals) ? Number( game?.defense_steals) : 0;
        const totalTO = (game && game?.defense_turn_over) ? Number( game?.defense_turn_over) : 0;
        const totalPoints = (game && game?.offense_points) ? Number( game?.offense_points) : 0;
        minutePlayed = minutePlayed/60;
        
        defaultTotalStats.totalMin += minutePlayed;
        defaultTotalStats.totalFGPercentage += threeFGPointPercentage;
        defaultTotalStats.totalThreePointPerc += threePointPercentage;
        defaultTotalStats.totalFreeThrowPerc += freeThrowAPercentage;
        defaultTotalStats.totalRebounds += totalRebounds;
        defaultTotalStats.totalAssists += totalAssist;
        defaultTotalStats.totalBLK += totalBlocks;
        defaultTotalStats.totalSTL += totalSteals;
        defaultTotalStats.totalTO += totalTO;
        defaultTotalStats.totalPTS += totalPoints;
      
        return <>
            <tr key={index}>
            <td>{game?.nba_week }</td>
            <td>{moment.utc(game?.schedule_date).tz("America/New_York").format('ddd, DD MMM')}</td>
            <td>{gameSymbol} {game.opponent_team_name}</td>
            {(game.has_started &&  !game.is_canceled ) ? <td>{winningStatus == 'W' && <span className="win">W </span> } 
            {winningStatus == 'L' && <span className="lost">L </span> } 
            {(winningStatus != 'W' && winningStatus != 'L') ? <span className="lost"> {winningStatus}&nbsp;</span> : ''}
            {finalScore}
            </td> : '' }
            {(game.is_schedule_canceled ) ? <td> 
                        <span className="lost">Canceled</span>
                    </td> : '' }

            {(!game.has_started &&  !game.is_schedule_canceled ) ? <td>
                {displayGameTime(game.schedule_date)} 
                </td> : '' }
            <td >{(minutePlayed) ? minutePlayed.toFixed(2) : (game.has_started) ? 0 : '--' }</td>
            <td >{(threeFGPointPercentage) ? threeFGPointPercentage.toFixed(2) : (game.has_started) ? 0 : '--' }</td>
            <td >{(threePointPercentage) ? threePointPercentage.toFixed(2) : (game.has_started) ? 0 : '--' }</td>
            
            <td >{(freeThrowAPercentage) ? freeThrowAPercentage.toFixed(2) : (game.has_started) ? 0 : '--' }</td>
            <td >{(totalRebounds) ? totalRebounds : (game.has_started) ? 0 : '--' }</td>
            <td >{(totalAssist) ? totalAssist: (game.has_started) ? 0 : '--' }</td>
            <td >{(totalBlocks) ? totalBlocks: (game.has_started) ? 0 : '--' }</td>
            <td >{(totalSteals) ? totalSteals: (game.has_started) ? 0 : '--' }</td>
            <td >{(totalTO) ? totalTO: (game.has_started) ? 0 : '--' }</td>
            <td >{(totalPoints) ? totalPoints: (game.has_started) ? 0 : '--' }</td>
        </tr>
        </>
    }

    const createWeeklyScoreRow = (index, game) => {
        let totalplayer_week_score = (game && game?.player_week_score) ? Number( game?.player_week_score) : 0;
        defaultTotalStats.totalWeeklyScore += totalplayer_week_score;
        return <>
            <tr key={index}>
                <td>{(totalplayer_week_score) ? totalplayer_week_score : (game.has_started) ? 0 : '--' }</td>
            </tr>
        </>
    }


    const SeasonSummary = (weeklyStats) => {
        let totalAssist =  0;
        let totalRebounds =  0
        let totalPoints = 0
        let threePointPercentage = 0;
        for(let stats of weeklyStats) {
            
            let threePointAttempted = (stats && stats?.fieldgoal_attempt) ? Number( stats?.fieldgoal_attempt) : 0;
            let threePointAMade = (stats && stats?.fieldgoal_made) ? Number( stats?.fieldgoal_made) : 0;
            threePointPercentage += (threePointAttempted > 0) ? (Number(threePointAMade)/Number(threePointAttempted))*100 : 0;

            totalAssist += (stats && stats?.offense_assists) ? Number( stats?.offense_assists) : 0;
            totalRebounds += (stats && stats?.total_rebounds) ? Number( stats?.total_rebounds) : 0
            totalPoints += (stats && stats?.offense_points) ? Number( stats?.offense_points) : 0
        }
       
        let summaryStats = {
            'totalFGPercentage': threePointPercentage,
            'totalRebounds': totalRebounds,
            'totalAssists': totalAssist,
            'totalPTS': totalPoints
        };
        setstatsSummary(summaryStats)
    }

    const playerPosition = (playerPosition) => {
        let positionName = '';
        if(playerPosition == 'C') {
            positionName = 'CENTER';
        } else if(playerPosition == 'G') {
            positionName = 'GUARD';
        } else if(playerPosition == 'F') {
            positionName = 'FORWARD';
        }
        return positionName;
    }

    return (
        <>
            {pageLoaded ? <Modal show={props.showplayermodal} onHide={props.handlePlayerModalClose} className="modal-playerdetail">
                {playerDetails.player_full_name && <Modal.Header closeButton>
                    {playerDetails.player_full_name && <div className={"player-info" + " " + (props.playerData.className)} >
                    {playerDetails.player_full_name ? <figure><img src={playerDetails.player_img_url} /></figure> : ''}
                        <div className="detail">
                            <div className='name'><h1>{playerDetails.player_full_name}</h1></div>
                            <div className="team">
                                <div className="pl-data"><img src={playerDetails.team_logo_url}/><p>{playerDetails.team_name}</p></div>
                                {playerDetails.player_number ? <div className="pl-data"><p>#{playerDetails.player_number}</p></div> : ''}
                                <div className="pl-data"><p>{playerPosition(playerDetails.player_position)} {playerDetails.player_rank ? '(Rank: ' + playerDetails.player_rank + ')' : ''}</p></div>
                            </div>
                            
                           <div className="activity">STATUS {playerDetails.is_player_active === 1 ? <p><span className="status active"></span>Active</p> : <p><span className="status deactive"></span>Inactive</p>}</div>

                        </div>
                    </div>}
                    <div className="season-stats">
                        <div className="stats-title">{currentSeason} Regular Seasons Stats</div>
                        <div className="stats-info">
                            <div className="info-block"><p>PTS</p><h4>{ Number(statsSummary.totalPTS)}</h4></div>
                            <div className="info-block"><p>REB</p><h4>{ Number(statsSummary.totalRebounds)}</h4></div>
                            <div className="info-block"><p>AST</p><h4>{ Number(statsSummary.totalAssists)}</h4></div>
                            <div className="info-block"><p>FG%</p><h4>{ Number(statsSummary.totalFGPercentage).toFixed(2)} </h4></div>
                        </div>

                    </div>


                </Modal.Header>}
                <Modal.Body>
                    <div className="game-wrap">
                         <h5>Next Game</h5>
                                        <div className="match-info">
                                        <div className="team-info first-team"><p>{(nextGameDetails.home_team == playerDetails.team_key) ? playerDetails.team_name : nextGameDetails.opponent_team_name} <span>{nextGameDetails.home_wins}-{nextGameDetails.home_loss}</span></p>{(nextGameDetails.home_team == playerDetails.team_key) ? <img src={playerDetails.team_logo_url}/> : <img src={nextGameDetails.opponent_team_logo_url}/>}</div>
                                        <div className="match-date">
                                            
                                            {/* <p><Moment format='DD/M'>{nextGameDetails.schedule_date}</Moment></p><p><Moment format='H:mm A'>{nextGameDetails.schedule_date}</Moment></p> */}
                                            <p>{moment.utc(nextGameDetails.schedule_date).tz("America/New_York").format('M/DD')} </p><p> {displayGameTime(nextGameDetails.schedule_date)} </p>
                                            </div>
                                        <div className="team-info second-team">{(nextGameDetails.away_team == playerDetails.team_key) ? <img src={playerDetails.team_logo_url}/> : <img src={nextGameDetails.opponent_team_logo_url}/>}<p>{(nextGameDetails.away_team == playerDetails.team_key) ? playerDetails.team_name : nextGameDetails.opponent_team_name} <span>{nextGameDetails.away_wins}-{nextGameDetails.away_loss}</span></p></div>
                                        </div>
                    </div>
                    <div className="game-log-sec">
                        <h5>Game Log</h5>
                        <div className="log-table-wrap">
                            <Table className="log-table" responsive>
                                <><thead>
                                    <tr>
                                        <th>{currentSeason} Regular season</th>
                                        <th>YTD Points</th>
                                    </tr>

                                </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <Table className="stat-table">
                                                    <thead>
                                                        <tr>
                                                            <th>WK</th>
                                                            <th>Date</th>
                                                            <th>Opponent</th>
                                                            <th>Result</th>
                                                            <th>MIN</th>
                                                            <th>FG%</th>
                                                            <th>3P%</th>
                                                            <th>FT%</th>
                                                            <th>REB</th>
                                                            <th>AST</th>
                                                            <th>BLK</th>
                                                            <th>STL</th>
                                                            <th>TO</th>
                                                            <th>PTS</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {gameStats.map((game, index) => (
                                                            createWeekRow(index, game)
                                                        ))}
                                                        <tr>
                                                            <th colSpan="4" className='total'>TOTAL</th>
                                                            <th>{ Number(defaultTotalStats.totalMin).toFixed(2)}</th>
                                                            <th>{ Number(defaultTotalStats.totalFGPercentage).toFixed(2)}</th>
                                                            <th>{ Number(defaultTotalStats.totalThreePointPerc).toFixed(2)}</th>
                                                            <th>{ Number(defaultTotalStats.totalFreeThrowPerc).toFixed(2)}</th>
                                                            <th>{ Number(defaultTotalStats.totalRebounds)}</th>
                                                            <th>{ Number(defaultTotalStats.totalAssists)}</th>
                                                            <th>{ Number(defaultTotalStats.totalBLK)}</th>
                                                            <th>{ Number(defaultTotalStats.totalSTL)}</th>
                                                            <th>{ Number(defaultTotalStats.totalTO)}</th>
                                                            <th>{ Number(defaultTotalStats.totalPTS)}</th>
                                                        </tr>
                                                    </tbody>

                                                </Table>
                                            </td>
                                            <td>
                                                <Table className="stat-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Score</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {gameStats.map((game, index) => (
                                                            createWeeklyScoreRow(index, game)
                                                        ))}
                                                        
                                                        <tr>
                                                            <th>{defaultTotalStats.totalWeeklyScore}</th>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </td>
                                        </tr>

                                    </tbody></>
                            </Table>
                        </div>
                    </div>
                    <Tabs
                        transition={false}
                        id="player-info-tab"
                        className="lineup-create-tab player-info-tab"
                        onSelect={(k) => changeTabs(k)}
                    >
                        <Tab eventKey="news" title="News">
                            <>
                                {(newsList.length > 0) && <div className="player-news">
                                    {newsList.map((news) => {
                                        return (
                                            <>
                                                <h4>{news.news_title}</h4>
                                                <p>{news.news_content}</p>
                                            </>

                                        )
                                    })}
                                </div>}

                                {newsPageData ? <Paginate paginationData={newsPageData} pageRows={newsList.length} onClick={() => { }} /> : ""}
                                {(!newsList.length && !showLoader) ? <div className="player-news"><span style={{ color: "red" }}>No records to display.</span></div> : ''}
                                {showLoader && <div className="loader-wrap"><div className="loader"></div></div>}
                            </>
                        </Tab>
                        <Tab eventKey="injury-report" title="Injury Report">
                            {(injuryReports.length) ? <div className="table-wrap">
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            {(position === 'DF') ? <th>Name</th> : ''}
                                            {(position === 'DF') ? <th>POS</th> : ''}
                                            <th>Date </th>
                                            <th>Status</th>
                                            <th>Injury Type</th>
                                            <th>Side</th>
                                            <th>Return Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {injuryReports.map((injury) => {
                                            return (
                                                <tr>
                                                    {(position === 'DF') ? <td>{injury.player_full_name}</td> : ''}
                                                    {(position === 'DF') ? <td>{injury.player_position}</td> : ''}
                                                    <td><Moment format='DD-MMMM'>{injury.imported_date}</Moment></td>
                                                    <td>{injury.player_injury_status}</td>
                                                    <td>{injury.player_injury_type}</td>
                                                    <td>{injury.player_injury_side}</td>
                                                    <td>{injury.player_return_date ? <Moment format='MM-DD-YYYY'>{injury.player_return_date}</Moment> : '-'}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                            </div> : ''}
                            {(!injuryReports.length && !showLoader) ? <div className="table-wrap" style={{ border: "0px" }}><span style={{ color: "red" }}>No injury reports to display.</span></div> : ''}
                            <div className="status-notation">
                                <h5>Status Notations:</h5>
                                <div className="notation-sec">
                                    <p><span>QUESTIONABLE: </span>Player is 50/50 to play</p>
                                    <p><span>DOUBTFUL: </span>Player has 75% chance of NOT playing</p>
                                    <p><span>OUT: </span>Player has been ruled out for the game</p>
                                    <p><span>INACTIVE: </span>Player appears on team's official gameday inactive list</p>
                                    <p><span>PUP-R: </span>Physically unable to perform list, during regular season</p>
                                    <p><span>PUP-P: </span>Physically unable to perform list, during preseason</p>
                                    <p><span>IR-R: </span>Injured reserve, but designated to return</p>
                                    <p><span>Reserve-DNR: </span>Reserve Did Not Report</p>
                                    <p><span>NFI-R: </span>Reserve Non-Football Injury</p>
                                    <p><span>NFI-A: </span>Active Non-Football Injury</p>
                                    <p><span>Reserve-CEL: </span>Reserve Commissioner Exempt List</p>
                                    <p><span>Reserve-Sus: </span>Reserve Suspended</p>
                                    <p><span>Reserve-Ret: </span>Reserve Retired</p>
                                    <p><span>Reserve-Ex: </span>Roster Exemption</p>
                                    <p><span>RESERVE-COVID-19: </span>Deals specifically with COVID-19 situations</p>
                                    <p style={{ border: "0px" }}><span>IR: </span>Injured Reserve</p>
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                </Modal.Body>
            </Modal> : ''}
        </>
    );

}

export default (PlayerStats);
